export default __webpack_public_path__ + "static/media/check.12c6ecc2.svg";